export default "__VITE_ASSET__DMokey5e__"